<div class="wrap">
  <header>
    <img title="Orbitax" src="https://dev-partners-wordpress-backup.s3.us-west-2.amazonaws.com/wp-content/uploads/2024/06/12171034/orbitax_logo_dark.svg" alt="Orbitax Logo">
  </header>
  <div class="welcome-message">
    <h1>{{title}}</h1>
    <p [innerHTML]="message"></p>
  </div>
</div>
